import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { RootStoreState } from 'src/app/store';
import { EndorsementsSelectors } from '../../store';

@Component({
    selector: 'app-required-checkbox-count',
    templateUrl: './required-checkbox-count.component.html',
    styleUrls: ['./required-checkbox-count.component.scss'],
    standalone: false
})
export class RequiredCheckboxCountComponent implements OnInit {
  requiredCheckboxTotal$: Observable<number>;
  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.requiredCheckboxTotal$ = this.store.pipe(
      select(EndorsementsSelectors.selectActiveDocumentRemainingCheckBoxes)
    );
  }
}
